// removed by extract-text-webpack-plugin
module.exports = {"header":"header-3N1cD","friendTotalLink":"friendTotalLink-3VrOW","linkContainer":"linkContainer-1VFTF","link":"link-2aPpa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/friends/_friendWidget.css
// module id = 1215
// module chunks = 1